import _ from "lodash";
import {LANGUAGE_MOTHER_YES} from "@/helper/characteristic/NaturalId";

export function isMotherLanguage (language)
{
	let isMotherLanguage = false;

	_.forEach(language.specificities, specificityAllocation =>
	{
		if (specificityAllocation.specificity.naturalId === LANGUAGE_MOTHER_YES)
		{
			isMotherLanguage = true;

			return false; // break
		}
	});

	return isMotherLanguage;
}
